import axios from 'axios';
import {
  GetTotalRecommendParamType,
  GetTotalRecommendType,
  GetWordCloudType,
  GetPopularContentsType,
} from './type';
import config from '../config-api.json';

const env = process.env.NODE_ENV;
let { apiInfo } = config;

if (env === 'development') {
  apiInfo = config.apiInfo_dev;
}

export async function apiGetTotalRecommend(info: GetTotalRecommendParamType) {
  const response = await axios.get<GetTotalRecommendType>(
    `${apiInfo.api_url}/total_recommend/`,
    {
      params: {
        total_count: info.total_count,
        session: info.session,
      },
    }
  );

  return response.data;
}

export async function apiGetPopularContents() {
  const response = await axios.get<GetPopularContentsType>(
    `${apiInfo.api_url}/popular_contents/`,
    {
      params: {
        targets: 'travel_info,recommended_info,course_info',
        size: 3,
      },
    }
  );

  return response.data;
}

export async function apiGetWordCloud() {
  const response = await axios.get<GetWordCloudType>(
    `${apiInfo.api_url}/manager/wordcloud/`,
    {}
  );

  return response.data;
}
